import Accordion from "@/common/components/Accordion"
import SelectController from "@/common/components/SelectController"
import { EstablishmentLeadsFunnelUpdateContractValidationSchema } from "@/features/establishmentLeadsFunnel/schemas/update.schema"
import { ContractData } from "@/features/establishmentLeadsFunnel/types/establishmentLead.type"
import { establishmentOptions as cycleOptions } from "@/features/privateCompanyLeadsFunnel/constants/cycleOptions.constant"
import { options as monthDaysOptions } from "@/features/privateCompanyLeadsFunnel/constants/monthDaysOptions.constant"
import { options as weekDaysOptions } from "@/features/privateCompanyLeadsFunnel/constants/weekDaysOptions.constants"
import { useMemo } from "react";
import { Control, UseFormSetValue, UseFormWatch, FieldErrors } from "react-hook-form"

interface ContractInvoiceDetailsProps {
  contract?: ContractData
  control: Control<EstablishmentLeadsFunnelUpdateContractValidationSchema, any>
  submit: () => void
  watch: UseFormWatch<EstablishmentLeadsFunnelUpdateContractValidationSchema>
  setValue: UseFormSetValue<EstablishmentLeadsFunnelUpdateContractValidationSchema>
  disableFields?: boolean
  errors: FieldErrors<EstablishmentLeadsFunnelUpdateContractValidationSchema>
}

export const ContractInvoiceDetails = ({
  contract,
  control,
  submit,
  watch,
  setValue,
  disableFields,
  errors,
}: ContractInvoiceDetailsProps) => {
  const watchCycle = watch('cycle');

  const getCycleStartDayDefaultValue = useMemo(() => {
    return contract?.cycle === 'weekly'
      ? contract?.cycle_start_day !== null && contract?.cycle_start_day !== undefined ? weekDaysOptions[contract?.cycle_start_day] : ''
      : monthDaysOptions.find(({ value }) => value === `${contract?.cycle_start_day}`);
  }, [contract?.cycle]);

  return (
    <Accordion
      name="contract_invoice_details"
      className="p-0"
      triggerClassName="p-4"
      contentClassName="p-4 pt-0"
      defaultOpen
      head={
        <p>Detalhes da fatura</p>
      }
      body={
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="cycle"
            label="Ciclo de fatura"
            defaultValue={cycleOptions.find(({ value }) => value === contract?.cycle)}
            options={cycleOptions}
            triggerOnChange={() => {
              setValue('cycle_start_day', null);
              submit();
            }}
            isDisabled={disableFields}
            errorMessage={errors.cycle?.message || ' '}
            markAsRequired
          />
          <div className="flex gap-2">
            <SelectController
              control={control}
              name="cycle_start_day"
              label="Dia de abertura"
              className="w-1/2"
              defaultValue={getCycleStartDayDefaultValue}
              options={
                (watchCycle?.value || contract?.cycle) === 'weekly'
                  ? weekDaysOptions
                  : monthDaysOptions(28)
              }
              triggerOnChange={submit}
              isDisabled={disableFields}
              errorMessage={errors.cycle_start_day?.message || ' '}
              markAsRequired
            />
            <SelectController
              control={control}
              name="closing_to_due_in_days"
              label="Vencimento da fatura"
              className="w-1/2"
              defaultValue={monthDaysOptions.find(({ value }) => value === `${contract?.closing_to_due_in_days}`) ? { label: `D+${monthDaysOptions.find(({ value }) => value === `${contract?.closing_to_due_in_days}`)?.label}`, value: contract?.closing_to_due_in_days} : null}
              options={monthDaysOptions.map((day) => ({ label: `D+${day.label}`, value: day.value }))}
              triggerOnChange={submit}
              isDisabled={disableFields}
              errorMessage={errors.closing_to_due_in_days?.message || ' '}
              markAsRequired
            />
          </div>
        </div>
      }
    />
  )
}
